import { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { userRisk } from "../../../services/apiCalls.js";
import RiskLevel from "./RiskLevel.jsx";

export default function RiskComponent({ selectedUser }) {
  const [riskHistory, setRiskHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const data = await userRisk(selectedUser.id);
        const sorted = (data || [])
          .map((item) => item.StratificationModel)
          .filter(Boolean)
          .sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
        setRiskHistory(sorted);
      } catch (error) {
        console.error("Error fetching risk history:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [selectedUser.id]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <RiskLevel riskHistory={riskHistory} />
    </Box>
  );
}
